export default {
    plans: {
        en: {
            _defaultDomain: 'https://builderall.com/',
            home: '{domain}home',
            plans: 'https://checkout.builderall.com/plans',
            ourTools: '{domain}our-tools',
            successStories: '{domain}new-success-stories',
            youtube: 'https://www.youtube.com/@BuilderallUSA',
            facebook: 'https://www.facebook.com/groups/builderall/?ref=share&mibextid=lURqYx',
            instagram: 'https://www.instagram.com/builderallofficial_/',
            getSupport: '{domain}support',
            login: 'https://office.builderall.com/us/office',
            getStart: 'https://checkout.builderall.com/plans',
            about: '{domain}about-us',
            affiliate: 'https://builderall.com/partner-programs',
            allTools: '{domain}/our-tools',
            tools: {
                website: 'https://tools.builderall.com/builderall-builder',
                emailMarketing: 'https://tools.builderall.com/mailingboss',
                courseCreator: 'https://tools.builderall.com/e-learning',
                chatbots: 'https://tools.builderall.com/messenger-chatbot',
                funnelBuilder: 'https://tools.builderall.com/funnel-builder',
                allTools: 'https://www.builderall.com/our-tools'
            },
            solutions: {
                healthWellness: 'https://www.builderall.com/solutions-health',
                realEstate: 'https://www.builderall.com/solutions-real-estate',
                freelancers: 'https://www.builderall.com/solutions-freelancer',
                agencies: 'https://www.builderall.com/solutions-agency',
                startups: 'https://www.builderall.com/solutions-startups',
                courseCreator: 'https://www.builderall.com/solutions-course-creator'
            },
            blog: 'https://thebuild.builderall.com',
            elements: '{domain}elements',
            partners: '{domain}partners',
            legalInformation: '{domain}legal-information',
            termsOfUse: '{domain}terms-of-use',
            privacyPolice: 'https://builderall.com/privacy-policy',
            cookiePolicy: 'https://builderall.com/cookie-policy',
            bigmenu: {
                ourTools: {
                    superchargeBundle: '{domain}supercharge-bundle',
                    websites: '{domain}builderall-builder',
                    funnels: '{domain}funnel-builder',
                    courses: '{domain}elearning-builder',
                    webinars: '{domain}webinar-builder',
                    ecommerce: '{domain}builderall-ecommerce',
                    chatbots: '{domain}chatbot',
                    mailingboss: '{domain}mailingboss',
                    messagerIgChatbots: '{domain}messenger--instagram-chatbot',
                    booking: '{domain}booking-builder',
                    ourTools: '{domain}our-tools',
                },
                solutions: {
                    healthWellness: '{domain}solutions-health',
                    agencies: '{domain}solutions-agency',
                    realEstate: '{domain}solutions-real-estate',
                    startup: '{domain}solutions-startups',
                    freelancer: '{domain}solutions-freelancer',
                    courseCreator: '{domain}solutions-course-creator',
                    builderallLearn: '{domain}learn',
                    builderallCertified: 'https://pro.fiverr.com/certified/builderall',
                    affiliate: '{domain}affiliates',
                    integration: '{domain}integrations'
                }
            }
        },
        pt: {
            _defaultDomain: 'https://br.builderall.com/',
            home: '{domain}home',
            plans: 'https://checkout.builderall.com/plans',
            ourTools: '{domain}nossas-ferramentas',
            successStories: '{domain}historias-sucesso',
            youtube: 'https://www.youtube.com/channel/UCCDeKQkMbxm18nYpQbqBlGQ',
            facebook: 'https://www.facebook.com/builderall.brasil.official/',
            instagram: 'https://www.instagram.com/builderallbroficial/',
            getSupport: 'https://builderall.com/pt-br/support/',
            login: 'https://office.builderall.com/br/office',
            getStart: 'https://checkout.builderall.com/plans',
            about: '{domain}sobre-nos',
            affiliate: 'https://br.builderall.com/partner-programs',
            allTools: '{domain}nossas-ferramentas',
            tools: {
                website: 'https://ferramentas-br.builderall.com/builderall-builder',
                emailMarketing: 'https://ferramentas-br.builderall.com/mailingboss',
                courseCreator: 'https://ferramentas-br.builderall.com/e-learning',
                chatbots: 'https://ferramentas-br.builderall.com/chatbuilder',
                funnelBuilder: 'https://ferramentas-br.builderall.com/funnel-builder',
                allTools: 'https://www.br.builderall.com/nossas-ferramentas'
            },
            solutions: {
                healthWellness: 'https://br.builderall.com/saude--bem-estar',
                realEstate: 'https://br.builderall.com/imobiliaria',
                freelancers: 'https://br.builderall.com/freelancers',
                agencies: 'https://br.builderall.com/agencias',
                startups: 'https://br.builderall.com/startups',
                courseCreator: 'https://br.builderall.com/cursos-online'
            },
            blog: 'https://thebuild.builderall.com',
            elements: '{domain}elementos',
            partners: 'https://builderall.com/pt-br/partners/',
            legalInformation: '{domain}informacoes-legais',
            termsOfUse: '{domain}termos-uso',
            privacyPolice: 'https://builderall.com/pt-br/privacy-policy',
            cookiePolicy: 'https://builderall.com/pt-br/cookie-policy',
            bigmenu: {
                ourTools: {
                    superchargeBundle: '{domain}supercharge-bundle',
                    websites: '{domain}website-builder',
                    funnels: '{domain}funnel-builder',
                    courses: '{domain}elearning-builder',
                    webinars: '{domain}webinar-builder',
                    ecommerce: 'https://builderall.com/pt-br/builderall-ecommerce',
                    chatbots: '{domain}chatbot',
                    mailingboss: '{domain}mailingboss',
                    messagerIgChatbots: '{domain}messenger--instagram-chatbot',
                    booking: '{domain}booking-builder',
                    ourTools: '{domain}nossas-ferramentas',
                },
                solutions: {
                    healthWellness: '{domain}saude--bem-estar',
                    agencies: '{domain}agencias',
                    realEstate: '{domain}imobiliaria',
                    startup: 'https://builderall.com/pt-br/solutions-startups',
                    freelancer: '{domain}freelancers',
                    courseCreator: 'https://builderall.com/pt-br/solutions-course-creator',
                    builderallLearn: '{domain}learn',
                    builderallCertified: 'https://8303a79b1e19a194f187-cerificados-builderall.site.builderall.net/feed?campaign=course_creators',
                    affiliate: '{domain}afiliados',
                    integration: '{domain}integracoes'
                }
            }
        },
        es: {
            _defaultDomain: 'https://es.builderall.com/',
            home: '{domain}home',
            plans: 'https://checkout.builderall.com/plans',
            ourTools: '{domain}nuestras-apps',
            successStories: '{domain}historias-exito',
            youtube: 'https://www.youtube.com/channel/UCNs5F6yOZkKvI-ZykvL0m9w',
            facebook: 'https://www.facebook.com/builderall.spanish/',
            instagram: 'https://www.instagram.com/builderall.es/',
            getSupport: 'https://builderall.com/es/support/',
            login: 'https://office.builderall.com/es/office',
            getStart: 'https://checkout.builderall.com/plans',
            about: 'https://builderall.com/es/about-us/',
            affiliate: 'https://builderall.com/es/affiliate-program/',
            allTools: '{domain}nuestras-apps',
            tools: {
                website: 'https://herramientas-es.builderall.com/builderall-builder',
                emailMarketing: 'https://herramientas-es.builderall.com/mailingboss',
                courseCreator: 'https://herramientas-es.builderall.com/e-learning',
                chatbots: 'https://herramientas-es.builderall.com/chatbot-messenger',
                funnelBuilder: 'https://herramientas-es.builderall.com/funnel-builder',
                allTools: 'https://es.builderall.com/nuestras-apps'
            },
            solutions: {
                healthWellness: 'https://es.builderall.com/soluciones---salud',
                realEstate: 'https://es.builderall.com/soluciones---bienes-raices',
                freelancers: 'https://es.builderall.com/soluciones---freelancer',
                agencies: 'https://es.builderall.com/soluciones---agencia',
                startups: 'https://es.builderall.com/soluciones---startups',
                courseCreator: 'https://es.builderall.com/soluciones---creador-de-cursos'
            },
            blog: 'https://thebuild.builderall.com',
            elements: '{domain}elementos',
            partners: 'https://builderall.com/es/partners/',
            legalInformation: '{domain}informacion-legal',
            termsOfUse: 'https://builderall.com/es/terms-of-use/',
            privacyPolice: 'https://builderall.com/es/privacy-policy/',
            cookiePolicy: 'https://builderall.com/es/cookie-policy/',
            domainRegistrationTerms: 'https://builderall.com/es/domain-registration-terms/',
            security: 'https://builderall.com/es/security/',
            accessibility: 'https://builderall.com/es/accessibility/',
            bigmenu: {
                ourTools: {
                    superchargeBundle: '{domain}supercharge-bundle',
                    websites: 'https://builderall.com/es/builderall-builder/',
                    funnels: 'https://builderall.com/es/funnel-builder/',
                    courses: 'https://builderall.com/es/elearning-builder/',
                    webinars: 'https://builderall.com/es/webinar-builder/',
                    ecommerce: '{domain}builderall-ecommerce',
                    chatbots: '{domain}chatbot',
                    mailingboss: 'https://builderall.com/es/mailingboss/',
                    messagerIgChatbots: '{domain}messenger--instagram-chatbot',
                    booking: 'https://builderall.com/es/booking-builder/',
                    ourTools: '{domain}nuestras-apps',
                },
                solutions: {
                    healthWellness: 'https://builderall.com/es/solutions-health/',
                    agencies: 'https://builderall.com/es/solutions-agency/',
                    realEstate: '{domain}soluciones---bienes-raices',
                    startup: 'https://builderall.com/es/solutions-startups/',
                    freelancer: '{domain}soluciones---freelancer',
                    courseCreator: 'https://builderall.com/es/solutions-course-creator/',
                    builderallLearn: 'https://builderall.com/es/learn/',
                    builderallCertified: 'https://pro.fiverr.com/certified/builderall?campaign=health_and_wellness',
                    affiliate: 'https://builderall.com/es/affiliate-program/',
                    integration: 'https://builderall.com/es/integrations/'
                }
            }
        },
        it: {
            _defaultDomain: 'https://it.builderall.com/',
            _domainPrimary: 'https://strumenti-it.builderall.com/',
            home: '{domain}',
            plans: 'https://checkout.builderall.com/plans',
            ourTools: '{domain}i-nostri-strumenti',
            successStories: '{domain}storie-di-successo',
            youtube: 'https://www.youtube.com/@BuilderallUSA',
            facebook: 'https://www.facebook.com/groups/builderall/?ref=share&mibextid=lURqYx',
            instagram: 'https://www.instagram.com/builderallofficial_/',
            getSupport: '{domain}supporto',
            login: 'https://office.builderall.com/it/office',
            getStart: 'https://checkout.builderall.com/plans',
            about: '{domain}chi-siamo',
            affiliate: 'https://italian-affiliati-eu-copy.cheetah.builderall.com/affiliati',
            allTools: '{domain}i-nostri-strumenti',
            tools: {
                website: 'https://strumenti-it.builderall.com/builderall-builder',
                emailMarketing: 'https://strumenti-it.builderall.com/mailingboss',
                courseCreator: 'https://strumenti-it.builderall.com/e-learning',
                chatbots: 'https://strumenti-it.builderall.com/chatbot-messenger',
                funnelBuilder: 'https://strumenti-it.builderall.com/costruttore-di-funnel',
                allTools: 'https://it.builderall.com/i-nostri-strumenti'
            },
            solutions: {
                healthWellness: 'https://it.builderall.com/soluzioni-salute',
                realEstate: 'https://it.builderall.com/soluzioni-immobiliare',
                freelancers: 'https://it.builderall.com/soluzioni-freelancer',
                agencies: 'https://it.builderall.com/soluzioni-agenzia',
                startups: 'https://it.builderall.com/soluzioni-startup',
                courseCreator: 'https://it.builderall.com/soluzioni-creatore-di-corsi'
            },
            blog: 'https://thebuild.builderall.com',
            elements: '{domain}elementi',
            partners: 'https://partners-it.builderall.com/',
            legalInformation: '{domain}informazioni-legali',
            termsOfUse: '{domain}termini-di-uso',
            privacyPolice: 'https://builderall.com/privacy-policy',
            cookiePolicy: 'https://builderall.com/cookie-policy',
            bigmenu: {
                ourTools: {
                    superchargeBundle: '{domain}supercharge-bundle',
                    websites: '{domainPrimary}builderall-builder',
                    funnels: '{domainPrimary}costruttore-di-funnel',
                    courses: '{domainPrimary}e-learning',
                    webinars: '{domainPrimary}webinar',
                    ecommerce: '{domainPrimary}builderallbuilder-e-commerce',
                    chatbots: '{domainPrimary}costruttore-chat-per-siti-web',
                    mailingboss: '{domainPrimary}mailingboss',
                    messagerIgChatbots: '{domainPrimary}instagram-chatbot',
                    booking: '{domainPrimary}booking',
                    ourTools: '{domain}i-nostri-strumenti',
                },
                solutions: {
                    healthWellness: '{domain}soluzioni-salute',
                    agencies: '{domain}soluzioni-agenzia',
                    realEstate: '{domain}soluzioni-immobiliare',
                    startup: '{domain}soluzioni-startup',
                    freelancer: '{domain}', //Avisar o alisson não tem
                    courseCreator: '{domain}soluzioni-creatore-di-corsi',
                    builderallLearn: '{domain}learn',
                    builderallCertified: 'https://pro.fiverr.com/certified/builderall',
                    affiliate: '{domain}affiliates',
                    integration: '{domain}integrazioni'
                }
            }
        },
        fr: {
            _defaultDomain: 'https://fr.builderall.com/',
            _domainPrimary: 'https://outils-fr.builderall.com/',
            home: '{domain}',
            plans: 'https://checkout.builderall.com/plans',
            ourTools: '{domain}our-tools',
            successStories: '{domain}histoires-a-succes',
            youtube: 'https://www.youtube.com/@BuilderallUSA',
            facebook: 'https://www.facebook.com/groups/builderall/?ref=share&mibextid=lURqYx',
            instagram: 'https://www.instagram.com/builderallofficial_/',
            getSupport: '{domain}page-support',
            login: 'https://office.builderall.com/fr/office',
            getStart: 'https://checkout.builderall.com/plans',
            about: '{domain}about-us',
            affiliate: 'https://affiliates.builderall.com/',
            allTools: '{domain}our-tools',
            tools: {
                website: 'https://outils-fr.builderall.com/builderall-builder',
                emailMarketing: 'https://outils-fr.builderall.com/mailingboss',
                courseCreator: 'https://outils-fr.builderall.com/e-learning',
                chatbots: 'https://outils-fr.builderall.com/chatbot-messenger',
                funnelBuilder: 'https://outils-fr.builderall.com/funnel-builder',
                allTools: 'https://fr.builderall.com/our-tools'
            },
            solutions: {
                healthWellness: 'https://fr.builderall.com/solutions---sante',
                realEstate: 'https://fr.builderall.com/solutions---agence-immobiliere',
                freelancers: 'https://fr.builderall.com/solutions---freelancer',
                agencies: 'https://fr.builderall.com/solutions---agence',
                startups: 'https://fr.builderall.com/solutions---startups',
                courseCreator: 'https://fr.builderall.com/solutions---createur-de-formation'
            },
            blog: 'https://thebuild.builderall.com',
            elements: '{domain}elements',
            partners: 'https://partners.builderall.com/',
            legalInformation: '{domain}informations-legales',
            termsOfUse: '{domain}conditions-d-utilisation',
            privacyPolice: 'https://builderall.com/privacy-policy',
            cookiePolicy: 'https://builderall.com/cookie-policy',
            bigmenu: {
                ourTools: {
                    superchargeBundle: '{domain}supercharge-bundle',
                    websites: '{domainPrimary}builderall-builder',
                    funnels: '{domainPrimary}funnel-builder',
                    courses: '{domainPrimary}e-learning',
                    webinars: '{domainPrimary}webinaires',
                    ecommerce: '{domainPrimary}e-commerce',
                    chatbots: '{domainPrimary}chatbot-messenger', //Chamar Held
                    mailingboss: '{domainPrimary}mailingboss',
                    messagerIgChatbots: '{domainPrimary}chatbot-messenger',
                    booking: '{domainPrimary}booking',
                    ourTools: '{domain}our-tools',
                },
                solutions: {
                    healthWellness: '{domain}solutions---sante',
                    agencies: '{domain}solutions---agence',
                    realEstate: '{domain}solutions---agence-immobiliere',
                    startup: '{domain}solutions---startups',
                    freelancer: '{domain}solutions---freelancer',
                    courseCreator: '{domain}solutions---createur-de-formation',
                    builderallLearn: '{domain}learn', //Chamar Held
                    builderallCertified: 'https://pro.fiverr.com/certified/builderall',
                    affiliate: '{domain}affiliates', 
                    integration: '{domain}integrations-page'
                }
            }
        },
        de: {
            _defaultDomain: 'https://www.builderall.de/',
            _domainPrimary: 'https://tools.builderall.de/',
            home: '{domain}',
            plans: 'https://checkout.builderall.com/plans',
            ourTools: '{domain}unsere-tools',
            successStories: '{domain}erfolgs-stories',
            youtube: 'https://www.youtube.com/@builderall.de_offical',
            facebook: 'https://www.facebook.com/builderallde',
            instagram: 'https://www.instagram.com/builderallofficial_/',
            getSupport: '{domain}support-seite',
            login: 'https://office.builderall.com/de/office',
            getStart: 'https://checkout.builderall.com/plans',
            about: '{domain}ueber-uns',
            affiliate: 'https://affiliates.builderall.de/',
            allTools: '{domain}unsere-tools',
            tools: {
                website: 'https://tools.builderall.de/builderall-builder',
                emailMarketing: 'https://tools.builderall.de/mailingboss',
                courseCreator: 'https://tools.builderall.de/e-learning',
                chatbots: 'https://tools.builderall.de/messenger-chatbot',
                funnelBuilder: 'https://tools.builderall.de/funnel-builder',
                allTools: 'https://builderall.de/unsere-tools'
            },
            solutions: {
                healthWellness: 'https://builderall.de/solutions-health',
                realEstate: 'https://builderall.de/solutions-real-estate',
                freelancers: 'https://builderall.de/solutions-freelancer',
                agencies: 'https://builderall.de/solutions-agency',
                startups: 'https://builderall.de/solutions-startups',
                courseCreator: 'https://builderall.de/solutions-course-creator'
            },
            blog: 'https://thebuild.builderall.com',
            elements: '{domain}elemente',
            partners: 'https://partners.builderall.com/',
            legalInformation: '{domain}impressum',
            termsOfUse: '{domain}nutzungsbedingungen',
            privacyPolice: 'https://builderall.com/privacy-policy',
            cookiePolicy: 'https://builderall.com/cookie-policy',
            bigmenu: {
                ourTools: {
                    superchargeBundle: '{domain}supercharge-bundle',
                    websites: '{domainPrimary}builderall-builder',
                    funnels: '{domainPrimary}funnel-builder',
                    courses: '{domainPrimary}e-learning',
                    webinars: '{domainPrimary}webinar',
                    ecommerce: '{domainPrimary}e-commerce',
                    chatbots: '{domainPrimary}website-chatbot',
                    mailingboss: '{domainPrimary}mailingboss',
                    messagerIgChatbots: '{domainPrimary}instagram-chatbot',
                    booking: '{domainPrimary}booking',
                    ourTools: '{domain}our-tools',
                },
                solutions: {
                    healthWellness: '{domain}solutions-health',
                    agencies: '{domain}solutions-agency',
                    realEstate: '{domain}solutions-real-estate',
                    startup: '{domain}solutions-startups',
                    freelancer: '{domain}solutions-freelancer',
                    courseCreator: '{domain}solutions-course-creator',
                    builderallLearn: '{domain}learn',
                    builderallCertified: 'https://pro.fiverr.com/certified/builderall',
                    affiliate: '{domain}affiliates',
                    integration: '{domain}integrationen'
                }
            }
        }
    }
}